import { DataProvider } from "./Data";
import { DataLoginProvider } from "./DataLogin";

export { DataContext } from "./Data";
export { DataLoginContext } from "./DataLogin";

export default {
  DataProvider,
  DataLoginProvider,
};
